import { useLang } from "@/lib/lang";
import { IMG } from "@/lib/constants";
import { BadgeCheck, Sparkles } from "lucide-react";

export default function About({ onOpenLead }) {
  const { t } = useLang();
  const pills = [t.about.pill_1, t.about.pill_2, t.about.pill_3, t.about.pill_4];
  return (
    <section className="py-20 md:py-28" style={{ background: "var(--bg-paper)" }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 relative lg:sticky lg:top-24">
          <div className="rounded-[36px] overflow-hidden shadow-xl border-4" style={{ borderColor: "var(--primary)" }}>
            <img
              src={IMG.manthan}
              alt="Dt. Manthan Sharma"
              className="w-full h-[540px] object-cover"
              style={{ objectPosition: "50% 25%" }}
            />
          </div>
          <div className="absolute -bottom-5 -right-4 md:right-6 rounded-2xl px-5 py-4 flex items-center gap-3 shadow-xl" style={{ background: "var(--bg)", border: "2px solid var(--primary)" }}>
            <BadgeCheck size={22} style={{ color: "var(--red)" }} />
            <div>
              <div className="text-[10px] uppercase tracking-widest font-bold" style={{ color: "var(--text-secondary)" }}>Certified · Registered</div>
              <div className="font-bold text-sm" style={{ color: "var(--primary)" }}>Dt. Manthan Sharma</div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="section-eyebrow">{t.about.eyebrow}</div>
          <h2 className="mt-3 font-display text-4xl md:text-6xl leading-[0.95]" style={{ color: "var(--primary)" }}>
            {t.about.title}
          </h2>
          <div className="mt-5 flex flex-wrap gap-2">
            {pills.map((p) => (
              <span key={p} className="inline-flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full" style={{ background: "var(--yellow)", color: "var(--primary)", border: "1.5px solid var(--primary)" }}>
                <Sparkles size={11} /> {p}
              </span>
            ))}
          </div>
          <div className="mt-8 space-y-5 text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
            <p>{t.about.body_p1}</p>
            <p>{t.about.body_p2}</p>
            <p>{t.about.body_p3}</p>
            <p style={{ color: "var(--text-primary)", fontWeight: 500 }}>{t.about.body_p4}</p>
          </div>
          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
            <Stat n="1000+" l="Clients transformed" />
            <Stat n="15+" l="Cities served" />
            <Stat n="10+" l="Years experience" />
          </div>
          <button data-testid="about-cta" onClick={onOpenLead} className="btn-primary mt-10">
            {t.hero.cta_primary}
          </button>
        </div>
      </div>
    </section>
  );
}

function Stat({ n, l }) {
  return (
    <div>
      <div className="font-display text-4xl md:text-5xl" style={{ color: "var(--red)" }}>{n}</div>
      <div className="text-[11px] uppercase tracking-widest mt-1 font-bold leading-tight" style={{ color: "var(--text-secondary)" }}>{l}</div>
    </div>
  );
}
